import Swiper from "swiper";

export default () => {
  
  projectsPageSlider();
  
  function projectsPageSlider() {
    let slider = document.querySelector(".projects__slider");
    if (slider) {
      let mainSlider = new Swiper(slider, {
        wrapperClass: "projects__slider-wrapper",
        slideClass: "projects__slide",
        slideActiveClass: "projects__slide--active",
        slidesPerView: 'auto',
        touchStartPreventDefault: false,
        loop: true,
        speed: 700,
        autoplay:true,
        navigation: {
          prevEl: '.projects__slider-btn--prev',
          nextEl: '.projects__slider-btn--next'
        },
         autoplay: {
          delay: 7000,
        },
        pagination: {
          el: '.projects__pagination',
          type: 'bullets',
          clickable: true,
        },
        lazy: {
          loadPrevNext: true,
          elementClass: 'projects__slide-img'
        }
      });
    }
  }
};
